import * as React from 'react';

type TransformProps = {
  $x?: number;
  $y?: number;
};

type Props = {transform?: TransformProps; children: React.ReactNode};

const PopoverBox = (props: Props) => {
  const x = (props.transform?.$x ?? 0) - 8;
  const y = (props.transform?.$y ?? 0) - 8;

  return (
    <div
      className="bg-popover text-popover-foreground outline-ring/50 max-h-[30vh] overflow-auto rounded-md p-2 shadow-lg outline-1"
      style={{transform: `translate(${x}px, ${y}px)`}}
    >
      <div className="-m-2">{props.children}</div>
    </div>
  );
};

export default PopoverBox;
